import React, { useEffect, useState } from "react";
import "./UsersPage.css";
import {
  getUser,
  getTenantUsers,
  getUserByUsername,
  impersonateUser,
} from "../../services/user-service";
import UserBase from "../../components/user/UserBase";
import SideBar from "../../components/sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { toast } from "react-toastify";

export default function UsersPage() {
  const [currentUser] = useState(getUser());
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (!currentUser) return;

    if (currentUser.role === "TENANT_ADMIN" || currentUser.role === "TENANT_USER") {
      getTenantUsers(currentUser.id)
        .then((res) => setUsers(res))
        .catch(() => {});
    } else {
      getUserByUsername(currentUser.username)
        .then((res) => setUsers([res.user]))
        .catch(() => {});
    }
  }, [currentUser]);

  const handleViewAssets = (user) => {
    navigate(`/organization/view-user-assets/${user.id}`);
  };

  const handleLoginAsAdmin = async (user) => {
    try {
      const response = await impersonateUser(user.id);

      if (response && response.success) {
        login();

        const targetUser = response.user;

        if (targetUser.role === "USER" || targetUser.role === "ORG_USER") {
          navigate("/user/dashboard");
        } else if (targetUser.role === "ATTORNEY") {
          navigate("/attorney/dashboard");
        } else if (
          targetUser.role === "BENEFICIARY" &&
          targetUser.firstlevelapproval === "true"
        ) {
          navigate("/beneficiary/dashboard");
        } else if (targetUser.role === "ADMIN") {
          navigate("/admin/dashboard");
        } else if (targetUser.role === "TENANT_ADMIN" || targetUser.role === "TENANT_USER") {
          navigate("/organization/dashboard");
        } else {
          navigate("/dashboard");
        }

        toast.success(`Logged in as ${targetUser.firstName}`);
      }
    } catch (error) {
      toast.error("Failed to login as user");
    }
  };

  const filteredUsers = users.filter(u =>
    u.role !== "TENANT_ADMIN" &&
    u.role !== "TENANT_USER" &&
    !(u.role === "ORG_USER" && u.commonId !== u.id)
  );

  return (
    <div className="your-component fade-in-element">
      <UserBase>
        <div style={{ marginTop: "4rem" }} className="otherElement">
          <SideBar>
            <div className="users_list_base">
              <div className="users_list_main">

                <div className="users_heading">
                  <h4>
                    {currentUser.role === "TENANT_ADMIN" || currentUser.role === "TENANT_USER"
                      ? `Organization Users (${filteredUsers.length})`
                      : "My Details"}
                  </h4>
                </div>

                <div className="users_container">
                  <div className="users_details_cards">

                    <div className="users_detail_card users_table_header">
                      <p className="users_row name_col"><strong>Name</strong></p>
                      <p className="users_row"><strong>Username</strong></p>
                      <p className="users_row email_col"><strong>Email</strong></p>
                      {(currentUser.role === "TENANT_ADMIN" || currentUser.role === "TENANT_USER") && (
                        <p
                          className="users_row"
                          style={{
                            flex: "0 0 280px",
                            textAlign: "center"
                          }}
                        >
                          <strong>Actions</strong>
                        </p>
                      )}
                    </div>

                    {users.length > 0 ? (
                      filteredUsers.map((u, idx) => (
                        <div key={idx} className="users_detail_card">
                          <p className="users_row name_col users_row_data users_row_data_name">
                            {u.firstName} {u.lastName}
                          </p>

                          <p className="users_row users_row_data">
                            {u.username}
                          </p>

                          <p className="users_row email_col users_row_data">
                            {u.email}
                          </p>

                          {(currentUser.role === "TENANT_ADMIN" || currentUser.role === "TENANT_USER") && (
                            <p
                              className="users_row users_row_data"
                              style={{
                                flex: "0 0 280px",
                                textAlign: "center",
                                display: "flex",
                                gap: "8px",
                                justifyContent: "center"
                              }}
                            >
                              {u.role !== "TENANT_ADMIN" ? (
                                <>
                                  <button
                                    onClick={() => handleViewAssets(u)}
                                    style={{
                                      padding: "8px 12px",
                                      backgroundColor: "#2C74B3",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      fontSize: "13px",
                                      fontWeight: "500"
                                    }}
                                  >
                                    View Assets
                                  </button>
                                  <button
                                    onClick={() => handleLoginAsAdmin(u)}
                                    style={{
                                      padding: "8px 12px",
                                      backgroundColor: "#4CAF50",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      fontSize: "13px",
                                      fontWeight: "500"
                                    }}
                                  >
                                    Login as Admin
                                  </button>
                                </>
                              ) : (
                                <span style={{ color: "#999", fontSize: "14px" }}>N/A</span>
                              )}
                            </p>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="users_detail_card">
                        <p className="users_row">
                          <strong>No users found</strong>
                        </p>
                      </div>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </SideBar>
        </div>
      </UserBase>
    </div>
  );
}